import { put, takeLatest } from 'redux-saga/effects';

import { requestIndustryList } from '../../../services/industry';
import { fetchIndustryListFailure, fetchIndustryListRequest, fetchIndustryListSuccess } from '../../reducers/industry';

export function* watchIndustrySaga() {
  yield takeLatest(fetchIndustryListRequest, fetchIndustryList);
}

/**
 *
 * @param {*} param0
 */
function* fetchIndustryList({ payload }) {
  try {
    const response = yield requestIndustryList(payload);
    yield put(fetchIndustryListSuccess(response));
  } catch (error) {
    yield put(fetchIndustryListFailure('Failed to get list of Leads'));
  }
}
